import {clearResource, setResource, setSaveStatusError} from 'redux/actions'
import reduxStore from 'redux/store'
import {RestRequestBLOB, RestRequestGET} from "../libs/RestRequest";
import Endpoints from "../constants/Endpoints";
import isResponseValid from "libs/isResponseValid";
import Tr from "translations/Translations";

const PAPERS_GENERATOR_LIST_RESOURCE_ID = 'papersGeneratorList';

const getAvailablePapers = async (id) => {
    try {
        const res = await RestRequestGET(Endpoints.PAPERS_GENERATOR(id));

        reduxStore.dispatch(
            setResource(PAPERS_GENERATOR_LIST_RESOURCE_ID, res)
        )
    } catch (error) {
    }
}


const getRfxRequestPosition = async (id) => {
    return await RestRequestGET(Endpoints.RFX_REQUEST_POSITION(id));
}

const getSwzParams = async (id) => {
    return await RestRequestGET(Endpoints.SWZ_PARAMS(id));
}

const getRfxInvitedSupplierWithOffer = async (id) => {
    return await RestRequestGET(Endpoints.RFX_INVITED_SUPPLIER_WITH_OFFER(id));
}

const getRfxInvitedSupplierPosition = async (id, supplierId) => {
    return await RestRequestGET(Endpoints.RFX_INVITED_SUPPLIER_POSITION(id, supplierId));
}


const getSwzGeneratorParams = async (demandId) => {
    const swzGeneratorParams = await RestRequestGET(Endpoints.SIWZ_GET_GENERATOR_PARAMS(demandId));
    return swzGeneratorParams;
}
const getRfxSupplierAttachmentsVerification = async (demandId, supplierId) => {
    const swzGeneratorParams = await RestRequestGET(Endpoints.GET_SUPPLIER_ATTACHMENTS_VERIFICATION(demandId, supplierId));
    return swzGeneratorParams;
}

const downloadPaper = async (url, successCallback = () => {
}, errorCallback = () => {
}) => {
    try {
        RestRequestBLOB(url)
            .then(successCallback)
            .catch(errorCallback);
    } catch (error) {
    }
}

const sharePaperByUrl = async (url, shareSystem) => {
    let params = {
        shareSystem
    }
    try {
        const resp = await RestRequestGET(url, {params});
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return resp.success;
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    return false;
}



const sharePaper = async (id, paper, shareSystem) => {
    try {
        const resp = await RestRequestGET(Endpoints.PAPERS_GENERATOR_PRINT_SHARE(id, paper, shareSystem));
        if (isResponseValid(resp, (e) => reduxStore.dispatch(setSaveStatusError(e)))) {
            return resp.success;
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    return false;
}

const clearResources = (resource) => reduxStore.dispatch(clearResource(resource));

export default {
    getAvailablePapers,
    clearResources,
    getRfxRequestPosition,
    getSwzParams,
    getRfxInvitedSupplierWithOffer,
    getRfxInvitedSupplierPosition,
    getRfxSupplierAttachmentsVerification,
    getSwzGeneratorParams,
    downloadPaper,
    sharePaper,
    sharePaperByUrl,
    PAPERS_GENERATOR_LIST_RESOURCE_ID
}